























































import Vue from "vue";
import IconCatalogTable from "@/components/icons/IconCatalogTable.vue";
import IconCatalogList from "@/components/icons/IconCatalogList.vue";
import IconCatalogSort from "@/components/icons/IconCatalogSort.vue";
import Checkbox from "@/components/inputs/Checkbox.vue";

interface ICatalogColumn {
  key: string;
  text: string;
  sortable: boolean;
}

export default Vue.extend({
  name: "catalog-header-column",
  components: {
    IconCatalogSort,
    IconCatalogTable,
    IconCatalogList,
    Checkbox,
  },
  props: {
    column: Object as () => ICatalogColumn,
    viewType: { type: String, default: "" },
    setType: { type: Function, default: () => null },
    sortBy: { type: String, default: "" },
    sortDirection: { type: String, default: "" },
    changeSort: { type: Function, default: () => null },
    hoverHandler: { type: Function, default: () => null },
    allSelected: { type: Boolean, default: false },
  },
});
